module.exports = __webpack_public_path__ + "static/media/warningAlert.99ef4552.svg";